import { fetches, feverApiFetchOpts, methods } from './commom';
import i18next from 'i18next';

/**
 * Generate OTP and send to user's email (extracted from Firebase ID token)
 * @param {string} [language] - Language preference ('zh-TW' or 'en-US')
 * @returns {Promise} API response
 */
export const generateOtpApi = async (language = null) => {
    const currentLanguage = language || i18next.language || 'zh-TW';

    try {
        return fetches(
            '/services/otp/generateOTP',
            feverApiFetchOpts({
                method: methods.POST,
                body: { language: currentLanguage }
            })
        );
    } catch (error) {
        console.error('OTP generation error:', error);
        throw error;
    }
};

/**
 * Validate OTP code
 * @param {string|number} otp - 6-digit OTP code
 * @returns {Promise} API response
 */
export const validateOtpApi = async otp => {
    try {
        return fetches(
            '/services/otp/validateOTP',
            feverApiFetchOpts({
                method: methods.POST,
                body: { otp }
            })
        );
    } catch (error) {
        console.error('OTP validation error:', error);
        throw error;
    }
};

/**
 * Revoke OTP verification status
 * Called when user needs to re-login
 * @returns {Promise} API response
 */
export const revokeOtpApi = async () => {
    try {
        return fetches(
            '/services/otp/revoke',
            feverApiFetchOpts({
                method: methods.DELETE
            })
        );
    } catch (error) {
        console.error('OTP revoke error:', error);
        throw error;
    }
};
